/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  // when the page loads, we need to get all the variant information and precheck our custom swatches
  var material = "";
  var color = "";
  var size = "";
  $(".selector-wrapper input:checked").each(function () {
    var id = $(this).attr("id");
    if (id.indexOf("material") > -1 || id.indexOf("materiaal") > -1) {
      // find the material and add to material_color
      material = id.split("--material-")[1];
      if (material) {
      } else {
        material = id.split("--materiaal-")[1];
      }
    }
    if (id.indexOf("kleur") > -1) {
      color = id.split("--kleur-")[1];
    }
    if (id.indexOf("maat") > -1) {
      size = "-" + id.split("--maat-")[1] + "-";
    }
  });
  // console.log("my material is " + material);
  $(".color-option input").each(function () {
    var thisFor = $(this).attr("id");
    var thisClass = $(this).attr("class");
    var combinedMatColor = material + "-" + color;
    if (
      thisFor.indexOf(combinedMatColor) > -1 &&
      thisClass.indexOf("collection") === -1
    ) {
      console.log("checking " + thisFor);
      $(this).prop("checked", true);
      $('label[for="' + thisFor + '"]').addClass("initial");
    }
  });
  $(".size-swatch-custom").each(function () {
    var thisFor = $(this).attr("id").toLowerCase();
    console.log("my this for is " + thisFor);
    if (thisFor.indexOf(size) > -1) {
      $(this).prop("checked", true);
      console.log("i am checking " + thisFor);
    }
  });
  // also when the page loads, if there are not enough colors/fabrics and there is no sizing step, then we set the button to add to  cart
  if (
    $(".centered pick-materials-link").length === 0 &&
    $(".step").length === 1
  ) {
    $(".pick-material").text("Toevoegen aan winkelwagen");
  }
  $("body").on("click", ".color-option label", function (e) {
    $(".initial").removeAttr("class");
    if (!$(this).attr("class")) {
      // we need to make sure we check all the radio buttons with this forlabel - including those with -button and -favorite and without the suffix (sometimes a -button and -favorite can be picked too)
      var forLabel = "#" + $(this).attr("for");
      // we need to make sure all radios are checked for this label / color
      var buttonLabel = forLabel + "-button";
      var material = $(forLabel).data("variant-material").toLowerCase();
      var kleur = $(forLabel).data("variant-kleur").toLowerCase();

      // Assuming 'this' is within the context of an event and refers to an element with a 'for' attribute
      var fullId = $(this).attr("for");

      // Extract the base ID by removing possible suffixes
      var baseId = fullId.replace(/-button$/, "").replace(/-favorite$/, "");

      // Construct selectors for each case
      var selectors = [
        "#" + baseId, // Base case
        "#" + baseId + "-button", // With '-button' suffix
        "#" + baseId + "-favorite", // With '-favorite' suffix
      ];
      $(".color-option input").each(function () {
        $(this).prop("checked", false);
      });
      // Now, use the selectors to match and perform actions on the corresponding elements
      selectors.forEach(function (selector) {
        // Example action: checking the radio button
        $(selector).prop("checked", true);
      });

      // we also need to find the proper material and fabric to show th proper image
      $(".selector-wrapper label").each(function () {
        var text = $(this).text().trim().toLowerCase();
        if (text === material) {
          $(this).trigger("click");
        }
        if (text === kleur) {
          $(this).trigger("click");
        }
      });
    } else {
      // we must be on a collection grid image and will try to replace it
      var newImg = $(this).find("img").attr("src");
      console.log("my parent is " + $(this).parent().parent().attr("class"));
      $(this)
        .parent()
        .parent()
        .find(".product-item__image")
        .find("img")
        .attr("src", newImg);
      $(this)
        .parent()
        .parent()
        .find(".product-item__image")
        .find("img")
        .attr("srcset", newImg);
      console.log("trying to replace image with " + newImg);
      // also if initial class exists, we are going to remove that
    }
    // if there is only 1 step and the input clicked contains button, then change the button to add to cart instead of pick material
    if (typeof forLabel != "undefined") {
      if (forLabel.indexOf("button") > -1 && $(".step").length === 1) {
        $(".pick-material").text("Toevoegen aan winkelwagen");
      }
    }
  });

  // Function to update the src of the target image based on the active media
  function updateFeaturedImageSrc() {
    const activeMedia = document.querySelector(
      ".product__slide.media--active img"
    );
    const targetImage = document.querySelector(".repeat-featured-image");
    if (activeMedia && targetImage) {
      targetImage.src = activeMedia.src;
    }
  }

  // Set up a MutationObserver to watch for class changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === "class") {
        updateFeaturedImageSrc();
      }
    });
  });

  // Options for the observer (which attributes to watch)
  var config = { attributes: true, subtree: true, attributeFilter: ["class"] };

  // Select the node that will be observed for mutations
  var targetNode = document.querySelector("body"); // Adjust this to be more specific if possible

  // Start observing the target node for configured mutations
  observer.observe(targetNode, config);
  var stepWrapper = document.querySelector(".step-wrapper");
  $("body").on("click", ".custom-fabric-picker-container label", function () {
    var MaatExist = 0;
    $(".pick-fabric.steps").each(function () {
      var text = $(this).text().trim();
      console.log("my texdt is " + text);
      if (text === "Kies maat") {
        MaatExist = 1;
      }
    });
    if (MaatExist === 1) {
      $(".pick-material").html(
        'Kies Maat <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none"><path d="M9.41418 7.6751H19.5436M15.6476 3L19.7718 7.12413C20.0761 7.42842 20.0761 7.92177 19.7718 8.22606L15.6476 12.3502" stroke="white" stroke-width="1.55837" stroke-linecap="round"></path></svg>'
      );
    }
  });
  $("body").on(
    "click",
    ".pick-material,.zdrawer__close,.step-overlay,.view-all-fabrics",
    function (e) {
      e.preventDefault();
      if ($(this).text().trim() === "Toevoegen aan winkelwagen") {
        // click the add to cart button since material is already selected
        if ($(".three-sizes-true").length === 0) {
          var count = 0;
          $(".size-swatch-custom:checked").each(function () {
            var name = $(this).attr("name");
            var text = $('.size-clicker[for="' + name + '"]')
              .contents()
              .filter(function () {
                return this.nodeType === 3; // Only get text nodes
              })
              .text()
              .trim();
            var mText = $('.size-clicker[for="' + name + '"]')
              .find(".size-name")
              .text()
              .trim();
            text = text + " (" + mText + ")";
            console.log("my text is " + text);
            if (count === 0) {
              $("#maatdetails1").val(text);
            } else {
              $("#maatdetails2").val(text);
            }
            count++;
          });
          $(".product-form").find('button[name="add"]').trigger("click");
          // setTimeout(function(){
          //   document.addEventListener("theme:cart:change", function (evt) {
          //     window.location.href = "/cart";
          //   });
          // },500);
          // var addButton = $(".product-form").find('button[name="add"]');
          // var productForm = $(".product-form");
          
          // if (addButton.length > 0) {
          //     addButton.show(); // Make the button visible temporarily
          
          //         // Manually submit the form via AJAX
          //         $.ajax({
          //             type: "POST",
          //             url: productForm.attr("action"),  // Get form action URL
          //             data: productForm.serialize(),    // Serialize form data
          //             success: function(response) {
          //                 // Optionally handle the response if needed (e.g., update cart UI)
          //                 console.log("Product successfully added to cart");
          //                 setTimeout(function(){
          //                   location.href="/cart";
          //                 }, );
          //             },
          //             error: function(error) {
          //                 console.log("Error while adding product to the cart" + error);
          //                 console.log(JSON.stringify(error, null, 2)); 
          //             }
          //         });
          
          //         addButton.hide(); // Hide the button again after submission
          // }
        } else {
          // we need to take all the selected variants and add them to cart now
          const items = [];
          var quantity = $(".zquantity__input").val();
          // loop through all items and add them to cart
          // get existing name id and add to items
          var value = $('input[name="id"]').attr("value");
          items.push({
            id: value,
            quantity: quantity,
          });
          $(".step").each(function () {
            var dataVariant = $(this).attr("data-variant-id");
          });
          if (dataVariant) {
            items.push({
              id: dataVariant,
              quantity: quantity,
              properties: { Maatdetails: text },
            });
          }
          // now that we have all the items, we put them in a form to be submitted
          const formData = {
            items: items,
          };

          $.ajax({
            url: "/cart/add.js",
            method: "POST",
            data: formData,
            processData: false, // Important for FormData
            contentType: false, // Important for FormData
            dataType: "json", // Expect a JSON response
            success: function (response) {
              console.log("Item added to cart:", response);
              // Optionally, update your cart UI here
              // setTimeout(function(){
              //   document.addEventListener("theme:cart:change", function (evt) {
              //     window.location.href = "/cart";
              //   });
              // },500);
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
              console.log(
                "Error adding item to cart:",
                XMLHttpRequest.responseJSON
              );
              // Handle error
            },
          });
        }
      } else {
        var targetClass = e.target.classList.value;
        var checkedFavSwatch = $(".color-swatch-custom.button:checked").length;
        if ($(".initial").length === 0) {
          // we leave this variable alone if there is no initial class, i.e. picked by default
        } else {
          // we remove this variable if initial exists since it's a fake selection, user didn't choose necessarily
          checkedFavSwatch = 0;
        }
        if (stepWrapper.classList.contains("open")) {
          stepWrapper.classList.remove("open");
          stepWrapper.classList.add("close");
          $("html").removeAttr("style");
          $(".step-overlay").hide();
        } else {
          stepWrapper.classList.remove("close");
          stepWrapper.classList.add("open");
          $("html").css("overflow-y", "hidden");
          var favorites = $(".favorite-fabrics").data("favorites");
          if (favorites === "yes" && targetClass != "view-all-fabrics") {
            $(".favorite-fabrics").hide();
            $(".all-fabric-list").show();
          } else {
            $(".favorite-fabrics").hide();
            $(".all-fabric-list").show();
          }
          if (checkedFavSwatch === 0 || targetClass === "view-all-fabrics") {
            $(".step.active").removeClass("active");
            $(".step-related.active").removeClass("active");
            $(".zquantity-selector").removeAttr("style");
            if ($(".step").length != 1) {
              $(".pick-next").text("Kies maat");
            }
            $(".step").eq(0).addClass("active");
            $(".step-related").eq(0).addClass("active");
            $(".repeat-featured-image").hide();
            $(".repeat-featured-image").eq(0).show();
          } else if (
            checkedFavSwatch === 1 &&
            targetClass != "view-all-fabrics"
          ) {
            $(".step.active").removeClass("active");
            if (
              $(".step").length >= 2
            ) {
              if ($(".step").length === 2) {
                $(".zquantity-selector").css("display", "flex");
                $(".pick-next").text("Toevoegen aan winkelwagen");
                $(".repeat-featured-image").hide();
              }
              $(".step-related").eq(1).addClass("active");
              $(".step").eq(1).addClass("active");
              $(".repeat-featured-image").hide();
              $(".repeat-featured-image").eq(1).show();
            } else if ($(".step").length === 1) {
              $(".zquantity-selector").css("display", "flex");
              $(".pick-next").text("Toevoegen aan winkelwagen");
              $(".step-related").eq(0).addClass("active");
              $(".step").eq(0).addClass("active");
            }
          }
          if (stepWrapper) {
            stepWrapper.scrollTop = 0;
          }
          $(".step-overlay").fadeIn("slow");
          if ($(".step").eq(0).hasClass("active")) {
            $(".quantity-container").hide();
            $(".quantity-container").removeAttr("style");
          }
        }
      }
    }
  );
  $("body").on("click", "#view-all", function () {
    $(".favorite-fabrics").hide();
    $(".all-fabric-list").show();
  });
  $("body").on("click", ".pick-materials-link", function (e) {
    if ($(this).attr("class").indexOf("collection") === -1) {
      e.preventDefault();
      $(".favorite-fabrics").hide();
      $(".all-fabric-list").show();
      $("html").css("overflow-y", "hidden");
      stepWrapper.classList.remove("close");
      stepWrapper.classList.add("open");
      $(".step-related.active").removeClass("active");
      $(".step.active").removeClass("active");
      $(".step-related").eq(0).addClass("active");
      $(".step").eq(0).addClass("active");
      $(".repeat-featured-image").hide();
      $(".repeat-featured-image").eq(0).show();
    } else {
      // let default link action happen
      // make sure the link is clicked
      window.location.href = $(this).find("a").attr("href");
    }
  });
  $("body").on("click", ".go-back", function (e) {
    e.preventDefault();
    var findStep = parseInt($(".step.active").index()) - 1;
    console.log("my find step index is " + findStep);
    if (findStep === 0) {
      $(".zdrawer__close").trigger("click");
    } else {
      console.log("trying to remove active class for existing element");
      $(".step.active").removeClass("active");
      $(".step-related.active").removeClass("active");
      $(".repeat-featured-image").hide();
      var newStep = findStep - 1;
      $(".repeat-featured-image").eq(newStep).show();
      $(".step").eq(newStep).addClass("active");
      $(".step-related").eq(newStep).addClass("active");
    }
    var length = $(".step").length;
    if (newStep + 1 === length) {
      $(".zquantity-selector").css("display", "flex");
      $(".btn-custom.pick-next").text("Toevoegen aan winkelwagen");
    } else {
      $(".zquantity-selector").hide();
      $(".zquantity-selector").removeAttr("style");
      $(".btn-custom.pick-next").text("Kies maat");
    }
  });
  // Select the node that will be observed for mutations
  var targetNode_two = document.querySelector(".product__price__wrap");
  if (targetNode_two) {
    // Options for the observer (which mutations to observe)
    var config_two = { attributes: true, childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback_two = function (mutationsList, observer_two) {
      // For each mutation record, we check and then copy the content
      for (let mutation of mutationsList) {
        if (mutation.type === "childList" || mutation.type === "attributes") {
          const contentToCopy = document.querySelector(
            ".product__price__wrap"
          ).innerHTML;
          document.querySelector(".custom-price-wrapper").innerHTML =
            contentToCopy;
        }
      }
    };

    // Create an instance of MutationObserver with the callback
    const observer_two = new MutationObserver(callback_two);

    // Start observing the target node for configured mutations
    observer_two.observe(targetNode_two, config_two);
  }
  $("#trustpilot-widget-trustbox-0-wrapper").click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
  });

  $("body").on("click", ".pick-next", function (e) {
    e.preventDefault();
    if ($(this).text().trim() === "Toevoegen aan winkelwagen") {
      if ($(".three-sizes-true").length === 0) {
        // we need to click the add to cart button for the user
        console.log(
          "my second option length is " +
            $(".second-option").length +
            " and my three step length is " +
            $(".three-step").length
        );
        if ($(".second-option").length > 0 && $(".three-step").length === 0) {
          // we need to trigger the custom size swatch
          console.log("trying to fire this thing");
          var prevSizeName = $(".size-holder")
            .eq(0)
            .find(".size-swatch-custom:checked")
            .next("label")
            .find(".size-name")
            .text()
            .toLowerCase();
          var sizeName = $(".size-holder")
            .eq(1)
            .find(".size-swatch-custom:checked")
            .next("label")
            .find(".size-name")
            .text()
            .toLowerCase();
          var found = false;
          var combinedsizeName = prevSizeName + " + " + sizeName;
          console.log(
            "my size name that I am looking for is  " + combinedsizeName
          );
          $(".selector-wrapper label").each(function () {
            var selectorName = $(this).attr("for");
            if (selectorName.indexOf("maat") > -1) {
              var text = $(this).text().trim().toLowerCase();
              // console.log('my selector text is ' + text);
              if (text.indexOf(combinedsizeName) > -1) {
                $(this).trigger("click");
                console.log("trying to click " + text);
                found = true;
                return false;
              }
            }
          });
          if (found === false) {
            // we need to change the order in case user picked in opposite way expected by variant
            var combinedsizeName = sizeName + " + " + prevSizeName;
            $(".selector-wrapper label").each(function () {
              var selectorName = $(this).attr("for");
              if (selectorName.indexOf("maat") > -1) {
                var text = $(this).text().trim().toLowerCase();
                console.log("my selector text is " + text);
                if (text.indexOf(combinedsizeName) > -1) {
                  $(this).trigger("click");
                  console.log("trying to click " + text);
                  return false;
                }
              }
            });
          }
        }
        var count = 0;
        $(".size-swatch-custom:checked").each(function () {
          var name = $(this).attr("name");
          var text = $('.size-clicker[for="' + name + '"]')
            .contents()
            .filter(function () {
              return this.nodeType === 3; // Only get text nodes
            })
            .text()
            .trim();
          var mText = $('.size-clicker[for="' + name + '"]')
            .find(".size-name")
            .text()
            .trim();

          text = text + " (" + mText + ")";
          console.log("my text is " + text);
          if (count === 0) {
            $("#maatdetails1").val(text);
          } else {
            $("#maatdetails2").val(text);
          }
          count++;
        });

        $(".product-form").find('button[name="add"]').trigger("click");
        // setTimeout(function(){
        //   document.addEventListener("theme:cart:change", function (evt) {
        //     window.location.href = "/cart";
        //   });
        // },500);
        
        // var addButton = $(".product-form").find('button[name="add"]');
        // var productForm = $(".product-form");
        
        // if (addButton.length > 0) {
        //     addButton.show(); // Make the button visible temporarily
        
        //         // Manually submit the form via AJAX
        //         $.ajax({
        //             type: "POST",
        //             url: productForm.attr("action"),  // Get form action URL
        //             data: productForm.serialize(),    // Serialize form data
        //             success: function(response) {
        //                 // Optionally handle the response if needed (e.g., update cart UI)
        //                 console.log("Product successfully added to cart");
        //                 location.href="/cart";
        //             },
        //             error: function(error) {
        //                 console.log("Error while adding product to the cart" + error);
        //                 console.log(JSON.stringify(error, null, 2)); 
        //             }
        //         });
        
        //         addButton.hide(); // Hide the button again after submission
        // }
        // move us back to step one after a few seconds
      } else {
        var thisId = $(".step.active")
          .find(".size-holder")
          .find(".size-swatch-custom:checked")
          .attr("id");
        console.log("my id is " + thisId);
        if (thisId) {
          // Check if thisId is not undefined
          var sizeName = $('label[for="' + thisId + '"]')
            .find(".size-name")
            .text()
            .toLowerCase();
          console.log("Size name is: " + sizeName);
        } else {
          console.log(
            "No checked .size-swatch-custom found within .step.active"
          );
        }
        // first we need to make sure current variant is selected
        $(".selector-wrapper label").each(function () {
          var selectorName = $(this).attr("for");
          if (selectorName.indexOf("maat") > -1) {
            var text = $(this).text().trim().toLowerCase();
            // console.log('my selector text is ' + text);
            if (text.indexOf(sizeName) > -1) {
              $(this).trigger("click");
              console.log("trying to click " + text);
              found = true;
              return false;
            }
          }
        });
        // we need to take all the selected variants and add them to cart now
        const items = [];
        var quantity = $(".zquantity__input").val();
        // loop through all items and add them to cart
        // get existing name id and add to items
        // since regular add to cart function handles this, then we dont even do this step
        /*
    var value = $('input[name="id"]').attr('value');
                    items.push({
          id: value,
          quantity: quantity
              });
      */
        $(".step").each(function () {
          var dataVariant = $(this).attr("data-variant-id");
          var name = $(this).find(".size-swatch-custom:checked").attr("name");
          var text = $(this)
            .find('.size-clicker[for="' + name + '"]')
            .contents()
            .filter(function () {
              return this.nodeType === 3; // Only get text nodes
            })
            .text()
            .trim();
          var mText = $(this)
            .find('.size-clicker[for="' + name + '"]')
            .find(".size-name")
            .text()
            .trim();
          text = text + " (" + mText + ")";
          if (dataVariant) {
            items.push({
              id: dataVariant,
              quantity: quantity,
              properties: {
                Afmeting: text,
              },
            });
          } else {
            // if it doesnt have a data variant, it's the last product and we must add this to the regular attributes
            $("#maatdetails1").val(text);
          }
        });
        // now that we have all the items, we put them in a form to be submitted
        const formData = {
          items: items,
        };
        $.ajax({
          url: "/cart/add.js",
          method: "POST",
          data: formData,
          dataType: "json", // Expect a JSON response
          success: function (response) {
            console.log("Item added to cart:", response);
              document.dispatchEvent(
                new CustomEvent("theme:cart:add", {
                  detail: {
                    response: response,
                    button: $(".product__block--buttons").find(
                      'button[name="add"]'
                    )[0],
                  },
                })
              );
            // setTimeout(function(){
            //   document.addEventListener("theme:cart:change", function (evt) {
            //     window.location.href = "/cart";
            //   }, 500);
            // })
              
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            console.log(
              "Error adding item to cart:",
              XMLHttpRequest.responseJSON
            );
            // Handle error
          },
        });
      }
      setTimeout(function () {
        $(".step.active").removeClass("active");
        $(".step-related.active").removeClass("active");
        $(".zdrawer__close").trigger("click");
        $(".pick-next").text("Kies maat");
        $(".zquantity-selector").hide();
        $(".zquantity-selector").removeAttr("style");
      }, 1500);
    } else {
      if ($(".three-sizes-true").length > 0) {
        var thisId = $(".step.active")
          .find(".size-holder")
          .find(".size-swatch-custom:checked")
          .attr("id");
        console.log("my id is " + thisId);
        if (thisId) {
          // Check if thisId is not undefined
          var sizeName = $('label[for="' + thisId + '"]')
            .find(".size-name")
            .text()
            .toLowerCase();
          console.log("Size name is: " + sizeName);
        } else {
          console.log(
            "No checked .size-swatch-custom found within .step.active"
          );
        }
        // first we need to make sure current variant is selected
        $(".product__block")
          .find(".selector-wrapper label")
          .each(function () {
            var selectorName = $(this).attr("for");
            if (selectorName.indexOf("maat") > -1) {
              var text = $(this).text().trim().toLowerCase();
              // console.log('my selector text is ' + text);
              if (text.indexOf(sizeName) > -1) {
                $(this).trigger("click");
                console.log("trying to click " + text);
                found = true;
                return false;
              }
            }
          });
        // we need to store the variant ID selected at this step on the button
        var value = $(".product__block").find('input[name="id"]').attr("value");
        var stepIndex = $(".step.active").index();
        if (stepIndex != 1) {
          $(".step.active").attr("data-variant-id", value);
        }
      }
      // get the index of the current active class
      var index = parseInt($(".step.active").index()) - 1;
      var newIndex = index + 1;
      console.log("my new index is " + newIndex);
      $(".repeat-featured-image").hide();
      $(".repeat-featured-image").eq(newIndex).show();
      var actualLength = newIndex + 1;
      $(".step.active").removeClass("active");
      $(".step-related.active").removeClass("active");
      $(".step-related").eq(newIndex).addClass("active");
      $(".step").eq(newIndex).addClass("active");
      var length = $(".step").length;
      var stepWrapper = document.querySelector(".step-wrapper.open");
      if (stepWrapper) {
        stepWrapper.scrollTop = 0;
      }
      if (actualLength === length) {
        $(".zquantity-selector").css("display", "flex");
        $(".btn-custom.pick-next").text("Toevoegen aan winkelwagen");
      } else {
        $(".zquantity-selector").hide();
        $(".zquantity-selector").removeAttr("style");
        $(".btn-custom.pick-next").text("Kies maat");
      }
    }
  });
  // Optionally, you can stop observing anytime if needed
  // observer.disconnect();
  $("body").on("change", ".size-swatch-custom", function (e) {
    // uncheck all others
    $(this).parent().find(".size-swatch-custom").prop("checked", false);
    $(this).prop("checked", true);
    var found = false;
    var thisId = $(this).attr("id");
    var sizeName = $('label[for="' + thisId + '"]')
      .find(".size-name")
      .text()
      .toLowerCase();
    if (
      $(this).hasClass("second-option") &&
      $(this).attr("class").indexOf("three-step") === -1
    ) {
      // we not only need this size name but we need to the previous option added to it
      var prevSizeName = $(".size-holder")
        .eq(0)
        .find(".size-swatch-custom:checked")
        .next("label")
        .find(".size-name")
        .text()
        .toLowerCase();
      console.log("my prev size name is " + prevSizeName);
      var combinedsizeName = prevSizeName + " + " + sizeName;
    } else {
      var combinedsizeName = sizeName;
    }
    console.log("my size name that I am looking for is  " + combinedsizeName);
    $(".selector-wrapper label").each(function () {
      var selectorName = $(this).attr("for");
      if (selectorName.indexOf("maat") > -1) {
        var text = $(this).text().trim().toLowerCase();
        // console.log('my selector text is ' + text);
        if (text.indexOf(combinedsizeName) > -1) {
          $(this).trigger("click");
          console.log("trying to click " + text);
          found = true;
          return false;
        }
      }
    });
    if (found === false) {
      // we need to change the order in case user picked in opposite way expected by variant
      var combinedsizeName = sizeName + " + " + prevSizeName;
      $(".selector-wrapper label").each(function () {
        var selectorName = $(this).attr("for");
        if (selectorName.indexOf("maat") > -1) {
          var text = $(this).text().trim().toLowerCase();
          console.log("my selector text is " + text);
          if (text.indexOf(combinedsizeName) > -1) {
            $(this).trigger("click");
            console.log("trying to click " + text);
            return false;
          }
        }
      });
    }
  });
  // if our custom quantity is changed, we must make that reflection in the regular shopify form
  $(".zquantity__input").change(function () {
    var value = $(this).val();
    $(".quantity__input").val(value);
  });
  // if the configure button is cliked, we need to take them back to the top of the screen
  $("body").on("click", "#cart-bar", function (e) {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
  // if someone clicks our custom quick add, we click the regular quick add
  $("body").on("click", ".quick-add-btn-custom", function (e) {
    e.preventDefault();
    console.log($(this).parent().attr("class"));
    $(this).parent().find(".quick-add__button").trigger("click");
  });
  // if someone clicks the photo on desktop or mobile, let's send them to choosing from all materials/fabrics
  var touchStartX = 0;
  var touchEndX = 0;
  var threshold = 30; // Minimum distance of movement to consider it a swipe

  $("body").on("touchstart", ".product-single__photos", function (e) {
    // Record start position
    e.preventDefault();
    touchStartX = e.originalEvent.touches[0].pageX;
  });
  /*
    $('body').on('touchend', '.product-single__photos', function(e) {
        // Record end position
        e.preventDefault();
        touchEndX = e.originalEvent.changedTouches[0].pageX;

        // Determine if it was a swipe or a tap
        if (Math.abs(touchStartX - touchEndX) < threshold) {
            // It's a tap, trigger the click for the button
            $('.pick-material').trigger('click');
        }
        // If it's more than the threshold, it's a swipe, do nothing or handle swipe here
    });
  
    $('body').on('click', '.product-single__photos', function(e) {
      // Optionally, you might want to check if touch was handled
      var target = e.target;
      console.log(target.classList);
      if (!e.handled && target.classList[0] != 'slider__button') {
          $('.pick-material').trigger('click');
      }
  });  
  */

  document.addEventListener("DOMContentLoaded", function () {
    // Callback function to execute when mutations are observed
    const callback = function (mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          const targetElement = mutation.target;
          const isActive = targetElement.classList.contains("media--active");
          if (
            isActive &&
            mutation.oldValue &&
            !mutation.oldValue.includes("media--active")
          ) {
            console.log("media--active has been added", targetElement);
            const dataImageId = targetElement.getAttribute("data-image-id");
            var imageElement = targetElement.querySelector("img");
            var imageAlt = imageElement
              ? imageElement.getAttribute("alt")
              : null;
            imageAlt = imageAlt.toLowerCase();
            $(".zproduct__thumb.mobile-thumb").removeClass("is-active");
            $(
              '.zproduct__thumb.mobile-thumb[data-media-id="' +
                dataImageId +
                '"]'
            ).addClass("is-active");
            if (imageAlt) {
              // loop through the material and colors and pick the matching one
              console.log(
                "trying to click " +
                  $('label[for="swatch-' + imageAlt + '"]').attr("for")
              );
              $('label[for="swatch-' + imageAlt + '"]').trigger("click");
            }
          } else if (
            !isActive &&
            mutation.oldValue &&
            mutation.oldValue.includes("media--active")
          ) {
            console.log("media--active has been removed", targetElement);
            // Call your function to handle the deactivation
          }
        }
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Options for the observer (which mutations to observe)
    const config = {
      attributes: true, // Observe attribute changes
      attributeOldValue: true, // Record the old value of the attribute
      attributeFilter: ["class"], // Observe only changes to the 'class' attribute
      subtree: true, // Observe the descendants of the specified target node
    };

    // Start observing the target node for configured mutations
    setTimeout(function () {
      const targetNode = document.querySelector(".product__images--thumbs");
      if (targetNode) {
        const config = { attributes: true, childList: true, subtree: true };
        const observer = new MutationObserver(function (
          mutationsList,
          observer
        ) {
          for (let mutation of mutationsList) {
            console.log(mutation);
          }
        });
        observer.observe(targetNode, config);
      }
    }, 1500); // Delay for 500 ms or adjust as needed

    // This function is used to handle the event
    function handleEvent(e) {
      // Check if the clicked element or any of its parents have the class 'header__mobile__right'
      if (
        e.target.closest(".custom-search") ||
        e.target.closest(".custom-mobile-search")
      ) {
        e.preventDefault(); // Prevents default behavior, if necessary
        $("header-search-popdown").attr("class", "is-open");
        $("header-search-popdown details").attr("open", "");
        // Place additional logic here if needed
      }
    }

    // Listen for click events
    document.addEventListener("click", handleEvent, false);

    // Listen for touchstart events
    document.addEventListener("touchstart", handleEvent, false);
  });

  class SwiperSlider extends HTMLElement {
    constructor() {
      super();
      this.config = JSON.parse(this.querySelector("script").innerHTML);
    }
    connectedCallback() {
      this.swiper = new Swiper(this, this.config);
    }
    disconnectedCallback() {
      this.swiper.destroy(true, true);
    }
  }

  customElements.define("swiper-slider", SwiperSlider);
  // custom cart slider functionality
  $(window).on("load", function () {
    if ($(".cart__item").length > 0) {
      console.log("loading countdown time");
      load_countdowntime();
    } else {
    }
  });
  document.addEventListener("theme:cart:change", function (evt) {
    console.log("cart changed");
    countdown_cart();
    $(".shipping-eligibilty").removeClass("hidden");
    if ($(".cart__price__holder").length > 0) {
      $(".cart__price__holder").load(location.href + " .cart__price__holder");
      $(".cart__price__holder").removeAttr("data-animation");
    }
  });
  document.addEventListener("theme:cart:add", function (evt) {
    console.log("theme cart added 2");
    countdown_cart();
    $(".shipping-eligibilty").removeClass("hidden");

  });
  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString(); // Changed toUTCString from toGMTString
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  var myVar;
  var xxx;
  function myStopFunction() {
    clearInterval(myVar);
  }
  function countdown_cart(origmins) {
    console.log("countdown cart time");
    myStopFunction();
    setCookie("visitor", "", 0);
    var minutesToAdd = 15;
    var currentDate = new Date();
    var countDownDate = new Date(
      currentDate.getTime() + minutesToAdd * 60000
    ).getTime();

    //    var countDownDate = new Date().getTime();
    setCookie("visitor", countDownDate, 1);
    var counter_new_time = getCookie("visitor");
    if (counter_new_time != "" && counter_new_time != null) {
      // Update the count down every 1 second
      function myTimer() {
        //    console.log('come');
        // Get today's date and time
        var now = new Date().getTime();

        // Find the distance between now and the count down date
        var distance = counter_new_time - now;

        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        if (seconds < 10) {
          seconds = "0" + seconds;
        }
        // Display the result in the element with id="demo"
        $(".timesnew").html(minutes + ":" + seconds + " ");

        // If the count down is finished, write some text
        if (distance < 0) {
          myStopFunction();
          setCookie("visitor", "", 0);
          $("#timesnew").html("");
        }
      }
      myVar = setInterval(myTimer, 1000);
    }
  }
  function load_countdowntime() {
    var minutesToAdd = 10;
    var currentDate = new Date();
    var countDownDate = new Date(
      currentDate.getTime() + minutesToAdd * 60000
    ).getTime();
    if (counter_new_time != "" && counter_new_time != null) {
      //    var countDownDate = new Date().getTime();
      setCookie("visitor", countDownDate, 1);
    }
    // console.log("Cookies currently:", document.cookie); // Log all cookies
    var counter_new_time = getCookie("visitor");
    // console.log("Retrieved counter new time:", counter_new_time); // Log retrieved time
    // Update the count down every 1 second
    function myTimer() {
      // console.log("come");
      // Get today's date and time
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = counter_new_time - now;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      // console.log("my distance is " + distance);
      // console.log(
      //   "trying to set up minutes" +
      //     minutes +
      //     " and trying to set up seconds as " +
      //     seconds
      // );
      // Display the result in the element with id="demo"
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      $(".timesnew").html(minutes + ":" + seconds + " ");

      // If the count down is finished, write some text
      if (distance < 0) {
        // console.log("stopping it and blocking timesnew");
        myStopFunction();
        countdown_cart();
      }
    }
    // console.log("trying to start this timer");
    myVar = setInterval(myTimer, 1000);
  }
  // $(".icon-bag").click(function (e) {
  //   e.preventDefault();
  //   window.location.href = "/cart";
  // });
  document
    .querySelector(".close-button")
    .addEventListener("click", function () {
      document.querySelector(".cart-overlay").style.display = "none";
    });

  document
    .querySelector(".continue-shopping")
    .addEventListener("click", function (event) {
      event.preventDefault(); // Prevent the link from navigating
      document.querySelector(".cart-overlay").style.display = "none";
    });

  // end of custom cart slider timing functionality
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this._interval = null;

    this.innerHTML = `
      <div class="countdown">
        <span id="cd-days">00</span>d :
        <span id="cd-hours">00</span>u :
        <span id="cd-minutes">00</span>m :
        <span id="cd-seconds">00</span>s
      </div>
    `;
  }

  connectedCallback() {
    const end = this.getAttribute('end-date');
    this._endTime = new Date(end).getTime();
    this._interval = setInterval(() => this._tick(), 1000);
    this._tick();
  }

  disconnectedCallback() {
    clearInterval(this._interval);
  }

  _tick() {
    const now = Date.now();
    const diff = this._endTime - now;

    if (diff <= 0) {
      clearInterval(this._interval);
      return;
    }

    const d = Math.floor(diff / 86400000);
    const h = Math.floor((diff % 86400000) / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);

    this.querySelector('#cd-days').textContent = String(d).padStart(2, "0");
    this.querySelector('#cd-hours').textContent = String(h).padStart(2, "0");
    this.querySelector('#cd-minutes').textContent = String(m).padStart(2, "0");
    this.querySelector('#cd-seconds').textContent = String(s).padStart(2, "0");
  }
}

customElements.define('countdown-t', CountdownTimer);
